import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useRecreateOn } from '../hooks/lifecycle';
/**
 * 当依赖变化时，重新构造 children。
 * 通常用于底层数据变化时（比如切换了用户），直接重新构造底层组件，以达到重新请求接口数据和渲染的效果。
 * 这种方法，比让底层组件的子组件 Hook 逐个观测底层数据的变化而言，更为简单和易维护。
 *
 * @category Util Component
 * @param args - Argument object
 * @param args.dep - 该值变为 true 时才开始渲染
 * @param args.children - React component children
 * @returns children | null
 *
 * @example
 * ```html
 * const Wrapper = () => {
 *   const { id } = useCurrentReflection()
 *   return<RecreateHOC dep={id}><Children ... /><RecreateHOC/>
 * }
 * ```
 */
export const RecreateHOC = ({ dep, children, }) => {
    const renderSign = useRecreateOn(dep);
    return renderSign && children ? _jsx(_Fragment, { children: children }, void 0) : null;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVjcmVhdGVIT0MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9SZWNyZWF0ZUhPQy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUtBLE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQTtBQUVsRDs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBa0JHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHLENBQUMsRUFDMUIsR0FBRyxFQUNILFFBQVEsR0FJVCxFQUFFLEVBQUU7SUFDSCxNQUFNLFVBQVUsR0FBRyxhQUFhLENBQUMsR0FBRyxDQUFDLENBQUE7SUFFckMsT0FBTyxVQUFVLElBQUksUUFBUSxDQUFDLENBQUMsQ0FBQyw0QkFBRyxRQUFRLFdBQUksQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFBO0FBQ3hELENBQUMsQ0FBQSJ9